import React, { useState } from 'react'

import PropTypes from 'prop-types'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab'

import { CreateNewField, SelectExistingField } from './components'
import StagedFragilitiesTable from '../StagedFragilitiesTable'

import useFetch from 'hooks/useFetch'

import * as service from 'service'
import constants from 'constants/index'

import useStyles from './styles'

const FragilityFields = ({
  selectedExisting,
  setSelectedExisting,
  stagedNew,
  setStagedNew,
  saving,
}) => {
  const [mode, setMode] = useState('select')

  const classes = useStyles()

  const { response, isLoading } = useFetch(
    service.dponet.companyFragilities.get,
    {
      status: constants.fragilities.ACTIVE,
      perPage: 9999,
      hideIsCompany: true,
      order: ['name ASC'],
    },
    [],
  )

  const companyFragilities = response?.data?.companyFragilities ?? []

  const handleStageNew = (fragility) =>
    setStagedNew((current) => [...current, fragility])

  const handleChangeMode = (_, value) => {
    if (!value) return
    setMode(value)
  }

  return (
    <>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={mode}
        onChange={handleChangeMode}
        className={classes.toggleGroup}
      >
        <ToggleButton
          value="select"
          disabled={saving}
          className={classes.toggleButton}
        >
          Selecionar existente
        </ToggleButton>
        <ToggleButton
          value="create"
          disabled={saving}
          className={classes.toggleButton}
        >
          Criar nova
        </ToggleButton>
      </ToggleButtonGroup>

      {mode === 'select' ? (
        <SelectExistingField
          companyFragilities={companyFragilities}
          isLoading={isLoading}
          selectedItems={selectedExisting}
          onChange={setSelectedExisting}
        />
      ) : (
        <>
          <CreateNewField
            companyFragilities={companyFragilities}
            stagedFragilities={stagedNew}
            onStage={handleStageNew}
            saving={saving}
          />

          <StagedFragilitiesTable
            stagedFragilities={stagedNew}
            setStagedFragilities={setStagedNew}
            saving={saving}
          />
        </>
      )}
    </>
  )
}

FragilityFields.propTypes = {
  selectedExisting: PropTypes.array,
  setSelectedExisting: PropTypes.func.isRequired,
  stagedNew: PropTypes.array,
  setStagedNew: PropTypes.func.isRequired,
  saving: PropTypes.bool,
}

export default FragilityFields
